import { SECTIONS, SECTION_MAP } from "@/lib/sections";
import { useSiteContent } from "@/context/SiteContentContext";

/**
 * Returns a copy of SECTIONS with any editor overrides applied.
 * Keys followed: rooms.<slug>.label, rooms.<slug>.overline,
 *                rooms.<slug>.description, rooms.<slug>.image
 */
export const useSections = () => {
  const { content } = useSiteContent();
  return SECTIONS.map((s) => ({
    ...s,
    label: content[`rooms.${s.slug}.label`] || s.label,
    overline: content[`rooms.${s.slug}.overline`] || s.overline,
    description: content[`rooms.${s.slug}.description`] || s.description,
    image: content[`rooms.${s.slug}.image`] || s.image,
  }));
};

export const useSection = (slug) => {
  const { content } = useSiteContent();
  const base = SECTION_MAP[slug];
  if (!base) return null;
  return {
    ...base,
    label: content[`rooms.${slug}.label`] || base.label,
    overline: content[`rooms.${slug}.overline`] || base.overline,
    description: content[`rooms.${slug}.description`] || base.description,
    image: content[`rooms.${slug}.image`] || base.image,
  };
};
